import { render, staticRenderFns } from "./SchedulesAdminPage.vue?vue&type=template&id=cb5c7e52"
import script from "./SchedulesAdminPage.vue?vue&type=script&lang=js"
export * from "./SchedulesAdminPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports